/* eslint-disable no-undef */
/* eslint-disable quotes */
/* eslint-disable camelcase */
/* eslint-disable no-invalid-this */
"use strict";
const angular = require("angular");
var counties = [];
var regionalCodes = [];
var zoningCodes = [];
var gpCodes = [];
var useCodes = [];
var dataDetail = {};

var mapCheck = false;
var dataCheck = false;
var dashboardCheck = false;

var hessPlanningSummary = {};
var hessEnviroSummary = {};
var hessSummary = {};

var cycle6 = {};
var parcelDetail = {};

var cities = [
  { organization_name: "Alameda", county: "Alameda" },
  { organization_name: "Albany", county: "Alameda" },
  { organization_name: "Berkeley", county: "Alameda" },
  { organization_name: "Dublin", county: "Alameda" },
  { organization_name: "Emeryville", county: "Alameda" },
  { organization_name: "Fremont", county: "Alameda" },
  { organization_name: "Hayward", county: "Alameda" },
  { organization_name: "Livermore", county: "Alameda" },
  { organization_name: "Newark", county: "Alameda" },
  { organization_name: "Oakland", county: "Alameda" },
  { organization_name: "Piedmont", county: "Alameda" },
  { organization_name: "Pleasanton", county: "Alameda" },
  { organization_name: "San Leandro", county: "Alameda" },
  { organization_name: "Unincorporated Alameda", county: "Alameda" },
  { organization_name: "Union City", county: "Alameda" },
  { organization_name: "Antioch", county: "Contra Costa" },
  { organization_name: "Brentwood", county: "Contra Costa" },
  { organization_name: "Clayton", county: "Contra Costa" },
  { organization_name: "Concord", county: "Contra Costa" },
  { organization_name: "Danville", county: "Contra Costa" },
  { organization_name: "El Cerrito", county: "Contra Costa" },
  { organization_name: "Hercules", county: "Contra Costa" },
  { organization_name: "Lafayette", county: "Contra Costa" },
  { organization_name: "Martinez", county: "Contra Costa" },
  { organization_name: "Moraga", county: "Contra Costa" },
  { organization_name: "Oakley", county: "Contra Costa" },
  { organization_name: "Orinda", county: "Contra Costa" },
  { organization_name: "Pinole", county: "Contra Costa" },
  { organization_name: "Pittsburg", county: "Contra Costa" },
  { organization_name: "Pleasant Hill", county: "Contra Costa" },
  { organization_name: "Richmond", county: "Contra Costa" },
  { organization_name: "San Pablo", county: "Contra Costa" },
  { organization_name: "San Ramon", county: "Contra Costa" },
  {
    organization_name: "Unincorporated Contra Costa",
    county: "Contra Costa",
  },
  { organization_name: "Walnut Creek", county: "Contra Costa" },
  { organization_name: "Belvedere", county: "Marin" },
  { organization_name: "Corte Madera", county: "Marin" },
  { organization_name: "Fairfax", county: "Marin" },
  { organization_name: "Larkspur", county: "Marin" },
  { organization_name: "Mill Valley", county: "Marin" },
  { organization_name: "Novato", county: "Marin" },
  { organization_name: "Ross", county: "Marin" },
  { organization_name: "San Anselmo", county: "Marin" },
  { organization_name: "San Rafael", county: "Marin" },
  { organization_name: "Sausalito", county: "Marin" },
  { organization_name: "Tiburon", county: "Marin" },
  { organization_name: "Unincorporated Marin", county: "Marin" },
  { organization_name: "American Canyon", county: "Napa" },
  { organization_name: "Calistoga", county: "Napa" },
  { organization_name: "Napa", county: "Napa" },
  { organization_name: "St Helena", county: "Napa" },
  { organization_name: "Unincorporated Napa", county: "Napa" },
  { organization_name: "Yountville", county: "Napa" },
  { organization_name: "San Francisco", county: "San Francisco" },
  { organization_name: "Atherton", county: "San Mateo" },
  { organization_name: "Belmont", county: "San Mateo" },
  { organization_name: "Brisbane", county: "San Mateo" },
  { organization_name: "Burlingame", county: "San Mateo" },
  { organization_name: "Colma", county: "San Mateo" },
  { organization_name: "Daly City", county: "San Mateo" },
  { organization_name: "East Palo Alto", county: "San Mateo" },
  { organization_name: "Foster City", county: "San Mateo" },
  { organization_name: "Half Moon Bay", county: "San Mateo" },
  { organization_name: "Hillsborough", county: "San Mateo" },
  { organization_name: "Menlo Park", county: "San Mateo" },
  { organization_name: "Millbrae", county: "San Mateo" },
  { organization_name: "Pacifica", county: "San Mateo" },
  { organization_name: "Portola Valley", county: "San Mateo" },
  { organization_name: "Redwood City", county: "San Mateo" },
  { organization_name: "San Bruno", county: "San Mateo" },
  { organization_name: "San Carlos", county: "San Mateo" },
  { organization_name: "San Mateo", county: "San Mateo" },
  { organization_name: "South San Francisco", county: "San Mateo" },
  { organization_name: "Unincorporated San Mateo", county: "San Mateo" },
  { organization_name: "Woodside", county: "San Mateo" },
  { organization_name: "Campbell", county: "Santa Clara" },
  { organization_name: "Cupertino", county: "Santa Clara" },
  { organization_name: "Gilroy", county: "Santa Clara" },
  { organization_name: "Los Altos", county: "Santa Clara" },
  { organization_name: "Los Altos Hills", county: "Santa Clara" },
  { organization_name: "Los Gatos", county: "Santa Clara" },
  { organization_name: "Milpitas", county: "Santa Clara" },
  { organization_name: "Monte Sereno", county: "Santa Clara" },
  { organization_name: "Morgan Hill", county: "Santa Clara" },
  { organization_name: "Mountain View", county: "Santa Clara" },
  { organization_name: "Palo Alto", county: "Santa Clara" },
  { organization_name: "San Jose", county: "Santa Clara" },
  { organization_name: "Santa Clara", county: "Santa Clara" },
  { organization_name: "Saratoga", county: "Santa Clara" },
  { organization_name: "Sunnyvale", county: "Santa Clara" },
  {
    organization_name: "Unincorporated Santa Clara",
    county: "Santa Clara",
  },
  { organization_name: "Benicia", county: "Solano" },
  { organization_name: "Dixon", county: "Solano" },
  { organization_name: "Fairfield", county: "Solano" },
  { organization_name: "Rio Vista", county: "Solano" },
  { organization_name: "Suisun City", county: "Solano" },
  { organization_name: "Unincorporated Solano", county: "Solano" },
  { organization_name: "Vacaville", county: "Solano" },
  { organization_name: "Vallejo", county: "Solano" },
  { organization_name: "Cloverdale", county: "Sonoma" },
  { organization_name: "Cotati", county: "Sonoma" },
  { organization_name: "Healdsburg", county: "Sonoma" },
  { organization_name: "Petaluma", county: "Sonoma" },
  { organization_name: "Rohnert Park", county: "Sonoma" },
  { organization_name: "Santa Rosa", county: "Sonoma" },
  { organization_name: "Sebastopol", county: "Sonoma" },
  { organization_name: "Sonoma", county: "Sonoma" },
  { organization_name: "Unincorporated Sonoma", county: "Sonoma" },
  { organization_name: "Windsor", county: "Sonoma" },
];

var infrastructureAccess = [{"infrastructure_access":"Yes - Current"}
,{"infrastructure_access":"YES - Current"}
,{"infrastructure_access":"YES - Planned"}
,{"infrastructure_access":"YES - Potential"}
,{"infrastructure_access":"None"}];

/*@ngInject*/
export function lookupService($http) {
  this.$http = $http;

  this.$http.get('https://data.bayareametro.gov/resource/i3y7-84ng.geojson?$limit=100000')
  .then(response => {
     cycle6 = response;
      console.log(response);
  })
  .catch(err => {
      console.log(err);
  })

  // Get Counties
  this.getCounties = function () {
    counties = [
      {
        FIPS: "CA001",
        County: "Alameda",
      },
      {
        FIPS: "CA013",
        County: "Contra Costa",
      },
      {
        FIPS: "CA041",
        County: "Marin",
      },
      {
        FIPS: "CA055",
        County: "Napa",
      },
      {
        FIPS: "CA075",
        County: "San Francisco",
      },
      {
        FIPS: "CA081",
        County: "San Mateo",
      },
      {
        FIPS: "CA085",
        County: "Santa Clara",
      },
      {
        FIPS: "CA095",
        County: "Solano",
      },
      {
        FIPS: "CA097",
        County: "Sonoma",
      },
      {
        FIPS: "CA999",
        County: "Regional",
      },
    ];
    return counties;
  };

  //Get Cities
  this.getCities = function () {
    return cities;
  };

  // Get County by City
  this.getCounty = function (city) {
    var countyCheck = _.filter(cities, { organization_name: city });
    var county = countyCheck[0].county;
    return county;
  };

  this.getRegionalCodes = function () {
    regionalCodes = [
      {
        id: 1,
        label: "Agriculture",
      },
      {
        id: 2,
        label: "Single Family Residential",
      },
      {
        id: 3,
        label: "Multi-Family Residential",
      },
      {
        id: 4,
        label: "Mixed Use Residential",
      },
      {
        id: 5,
        label: "Mixed Use Commercial",
      },
      {
        id: 6,
        label: "Commercial",
      },
      {
        id: 7,
        label: "Industrial",
      },
      {
        id: 8,
        label: "Transportation",
      },
      {
        id: 9,
        label: "Parks and Open Space",
      },
      {
        id: 10,
        label: "Public and Institutional",
      },
      {
        id: 11,
        label: "Conservation and Ecology Areas",
      },
      {
        id: 12,
        label: "Specific or Special Plan Areas",
      },
      {
        id: 999,
        label: "Unclassified",
      },
    ];
    return regionalCodes;
  };

  //Zoning Codes
  this.setZoningCodes = function (codes) {
    zoningCodes = codes;
  };

  this.getZoningCodes = function () {
    return zoningCodes;
  };

  //GP Codes
  this.setGPCodes = function (codes) {
    gpCodes = codes;
  };

  this.getGPCodes = function () {
    return gpCodes;
  };

  //Use Codes
  this.setUseCodes = function (codes) {
    useCodes = codes;
  };

  this.getUseCodes = function () {
    return useCodes;
  };

  //Data Source Details
  this.setDataDetail = function (data) {
    dataDetail = data;
  };

  this.getDataDetail = function () {
    return dataDetail;
  };

  this.getHessCategoryLayers = function () {
    return [
      { name: "Green", color: "#199694", desc: "Vacant Non-Residential Sites" },
      {
        name: "Yellow",
        color: "#ffb73b",
        desc: "Non-Vacant Residential Sites",
      },
      {
        name: "Red",
        color: "#D60D3B",
        desc: "Environmentally Constrained Sites",
      },
      { name: "Orange", color: "#ff6d12", desc: "Vacant Residential Sites" },
      { name: "Pink", color: "#ff57bc", desc: "Public Sites" },
      {
        name: "Blue",
        color: "#0C7CBA",
        desc: "Non-Vacant Non-Residential Sites",
      },
      { name: "Gray", color: "gray", desc: "Unclassified Sites" },
      // ,{ name: 'List', color: '#824086', desc:'My Sites' }
    ];
  };

  //Count summaries
  //Planning Summary
  this.getHessPlanningSummary = function () {
    return hessPlanningSummary;
  };

  this.setHessPlanningSummary = function (summary) {
    hessPlanningSummary = summary;
  };

  //Enviro Summary
  this.getHessEnviroSummary = function () {
    return hessEnviroSummary;
  };

  this.setHessEnviroSummary = function (summary) {
    hessEnviroSummary = summary;
  };

  //Hess Category Summary
  this.getHessSummary = function () {
    return hessSummary;
  };

  this.setHessSummary = function (summary) {
    hessSummary = summary;
  };

  //Data Disclaimer Modal Check
  this.getModalCheck = function (type) {
    if(type === 'map'){
      return mapCheck;
    } else if(type === 'data'){
      return dataCheck;
    } else if(type === 'dashboard'){
      return dashboardCheck;
    }
  };

  this.setModalCheck = function (type, status) {
    if(type === 'map'){
      mapCheck = status;
    }else if(type === 'data'){
      dataCheck = status;
    } else if(type === 'dashboard'){
      dashboardCheck = status;
    }
  };

  this.getCycle6 = function(){
    return cycle6;
  }

  this.setCycle6 = function(data){
    cycle6 = data;
  }

  this.getParcelDetail = function(){
    return parcelDetail;
  }

  this.setParcelDetail = function(data){
    parcelDetail = data;
  }

  // Infrastructure access lookup 
  this.getInfrastructureAccess = function(){
    return infrastructureAccess;
  }


}

export default angular
  .module("hessApplicationApp.lookup", [])
  .service("lookup", lookupService).name;



// WEBPACK FOOTER //
// ./client/components/services/lookup/lookup.service.js